// A/B arm for the onboarding fast path (FAST_PATH_WIZARD). Pure and client-safe.
import { simpleHash } from '@/utils/feature-flags';

export type WizardVariant = 'control' | 'fast';

export interface VariantInput {
  enabled: boolean;
  rolloutPercent: number;
  visitorId: string | null;
  /** ?wizard=fast|control, for QA. Only honoured while the flag is on. */
  override?: string | null;
}

export function assignWizardVariant({ enabled, rolloutPercent, visitorId, override }: VariantInput): WizardVariant {
  if (!enabled) return 'control';
  if (override === 'fast' || override === 'control') return override;
  if (!visitorId) return 'control';
  const pct = Number.isFinite(rolloutPercent) ? Math.min(100, Math.max(0, rolloutPercent)) : 0;
  return simpleHash(`fast-path:${visitorId}`) % 100 < pct ? 'fast' : 'control';
}
